module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-panel-container",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('section', {
    staticClass: "notification-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "head row"
  }, [_c('span', {
    staticClass: "icon-volet-notif"
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNotifications\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "close icon-form-close",
    on: {
      "click": _vm.setActive
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "day"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("moment")(new Date(), 'dddd DD MMMM')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-notifications"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "notification"
    }, [(notification.type === 'article') ? _c('div', {
      staticClass: "head-notif row"
    }, [_c('span', {
      staticClass: "icon-notif-article"
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Nouvel Article")]), _vm._v(" "), _c('div', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.date, 'HH[h]mm')))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "body-notif"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(notification.text) + "\n\t\t\t\t")])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76d3ec58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification-panel.vue
// module id = 632
// module chunks = 1